import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { FaEllipsisVertical } from "react-icons/fa6";
import { IconDeleteSolid, IconSolidEdit } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { RxReload } from "react-icons/rx";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import axios from "axios";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import useTablePage from "../../../components/CommonComponents/useTablePage";
import { ActionFormatterComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";

function RoleIndex() {
  const { fetchRequest } = useMyContext()
  const labelSource = 'roles-and-permission'
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/user-permission/index`
  const multiDelete = `${BaseUrl}/admin/user-permission/multi-delete`
  const labelApi = `${BaseUrl}/admin/Label-Management/list-source?source=${labelSource}`
  const headers = getItemToken('access_token')

  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [formData, setFormData] = useState({
    state: "formData",
  })

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: { page, limit, title: formData?.role_name },
      data: {},
    })
      .then(response => {
        const result = response;
        setApiData(result?.data);
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: { title: find == "ALL" ? null : formData?.title, type: null, page, limit: find == "ALL" ? total?.count_all : total?.totalItems },
      data: {},
    })
    const result = data?.data
    if (type == "CSV") {
      await donwloadCSV(result, "ROLE-AND-PERMISSION-LIST")
    }
    if (type == "PDF") {
      await downloadPDF(result, "ROLE-AND-PERMISSION-LIST", ["INDEX", "ID", "ROLE NAME", "ROLE TYPE", "ACCESS TYPE", "CREATED AT"])
    }
    if (type == "XLSX") {
      await downloadXLSX(result, "ROLE-AND-PERMISSION-LIST", ["INDEX", "ID", "ROLE NAME", "ROLE TYPE", "ACCESS TYPE", "CREATED AT"])
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err?.response?.data?.message)

    }
  }

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete },
      headers: headers,
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([])
          setShowOverlay(false)
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message);
        setShowOverlay(false)
      })
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const columns = [
    {
      dataField: "role_name",
      text: "Role",
      width: "30%",
      formatter: (cell, row) =>
        <>
          <h4 className='table-column-title  mb-2'>{row?.role_name}</h4>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-start'>
            <span className='dateText table-subheading theme-text-color'>{row?.upload_on}</span>
          </div>
        </>,
      sort: true,
    },
    {
      dataField: "role_type",
      text: "Role Type",
    },
    {
      dataField: "access_name",
      text: "Access Type",
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={"/role-edit/"} action={singleDelete} />,

      // formatter: (cell, row) =>
      //   <div className="editdropdown">
      //     <span className="editdropdown-button">
      //       <FaEllipsisVertical />
      //     </span>
      //     <div className="editdropdown-menu theme-bg-color">
      //       <Link to={`${"/role-edit/"}${row?.id}`} className="theme-text-color  theme-bg-color">
      //         <span className="theme-text-color">
      //           <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
      //           <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
      //         </span>
      //       </Link>
      //       <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
      //         <IconDeleteSolid styled={{ width: "20px", height: "20px" }} />
      //         <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
      //       </div>
      //     </div>
      //   </div>
      // ,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  const reloadAction = () => {
    setWithoutRefresh(prev => !prev)
  }
  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };
  useEffect(() => {
    labelFetch()
  }, [])
  useEffect(async () => {
    fetchData();
  }, [page, limit, formData?.role_name, withOutRefresh]);


  return (
    <>
      <div className='mb-4'>
        {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
        {showOverlay && <Response_Processing />}
        <AdminNavbar heading={labelDisplay?.[0]?.title} totalDataLength={total?.totalItems} deleteCount={itemToDelete?.length} navigation={"/role-create"} deleteMethod={openModal} navText={labelDisplay?.[0]?.sub_title} />
        <div className='theme-bg-color p-3 rounded-3 mb-5'>
          <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
            <input type='search' id="filter-search" placeholder='Search role name' name="role_name" className='rounded-3  theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} />
            <div className=' d-flex align-items-center'>

              <button className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color }`} onClick={reloadAction}>
                <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
              </button>
              <div className="dropdown d-block ms-2 " key={"2"}>
                {/* <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                  <span className="fw-bolder text-white">Export</span>
                  <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                </button> */}
                <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX </li>
                </ul>
              </div>
              <div className="dropdown d-block ms-2 " key={"2"}>
                <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                  <span className="fw-bolder text-white">Export all</span>
                  <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                </button>
                <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                  <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
                </ul>
              </div>
            </div>
          </div>

          <AdminTable data={apiData}
            loading={loading}
            options={options}
            handlePageChange={handlePageChange}
            page={page}
            pagination={total}
            handleSizePerPageChange={handleSizePerPageChange}
            columns={columns}
            limit={limit}
            selectRow={selectRow}
            onRowSelect={handleRowSelect}
            onSort={handleSort}
            onSelectAll={handleSelectAll}
            viewType={"list"}
          />
        </div >
      </div >
    </>
  );
}

export default RoleIndex;